import React from 'react'
import InputSearch from './InputSearch'

function CustomerManagerFilters(props) {
    const {filters, setFiltersState} = props

    const _handleChangeInput = (name, value) => {
        const newState = {
            [name]: value
        }
        setFiltersState(newState)
    }

    return <div className="CallHistoryFilters Filters row">
        <div className="itemFilter col-sm-2 mb-3">
            <InputSearch
                label="Tên KH"
                name="name"
                value={filters.name || ''}
                onChange={_handleChangeInput}
            />
        </div>
        <div className="itemFilter col-sm-2 mb-3">
            <InputSearch
                label="Số điện thoại"
                name="phone"
                value={filters.phone || ''}
                onChange={_handleChangeInput}
            />
        </div>
    </div>
}

export default CustomerManagerFilters
